import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {TENANT_INFO_URL, TENANTS_URL} from '../api-config';
import {Observable, of} from 'rxjs';
import {catchError, map, retry} from 'rxjs/operators';
import {Tenant, TenantInfo} from './tenant.model';

@Injectable({
  providedIn: 'root'
})
export class TenantService {

  currentTenantInfo: TenantInfo | undefined;

  constructor(private httpClient: HttpClient) { }

  getCurrentTenantInfo(): Observable<TenantInfo> {
    if (this.currentTenantInfo){
      return of(this.currentTenantInfo);
    }
    return this.httpClient.get<TenantInfo>(TENANT_INFO_URL).pipe(
      catchError(error => {
        if (error?.status === 404){
          return of(new TenantInfo());
        }
        throw error;
      }),
      retry(10),
      map(tenantInfo => {
        this.currentTenantInfo = tenantInfo;
        return tenantInfo;
      }));
  }

  redirectToSubdomain(tenantId: string): Observable<Tenant> {
    return this.httpClient.get<Tenant>(TENANTS_URL + '/' + tenantId).pipe(retry(10)).pipe(map(
      tenant => {
        window.location.href = 'https://' + tenant.domains[0] + window.location.pathname + window.location.search + window.location.hash;
        return tenant;
      })
    );
  }

  getTenantById(tenantId: string): Observable<Tenant> {
    return this.httpClient.get<Tenant>(TENANTS_URL + '/' + tenantId);
  }
}
